import React, { useEffect, useState } from "react";
import { Routes, Route, Outlet, useNavigate } from "react-router-dom";



import { useDispatch, useSelector } from "react-redux";

import "./MappingStatus.css";
import { Box } from "@mui/material";
import CreateDataMapping from "../CreateDataMapping/CreateDataMapping";
import Pagination from "../../components/Pagination/Pagination";
import { getAllMappingDetails } from "../../apis/dataMapping/dataMapping";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MappingStatusActions from "../../components/MappingStatusActions/MappingStatusActions";


function MappingStatus() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector((state: any) => state.clientDetails.activeClient);

  const [mappingList, setMappingList] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState<any>(10);

  // Get current Rows
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = mappingList.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  const rowCountRange = [10, 25, 50, 100];

  useEffect(() => {
    getAllMappings();
  }, []);

  const getAllMappings=()=>{
    getAllMappingDetails((resp: any) => {
      if (resp) {
        setMappingList(resp.Data);
      } else {
        navigate("/errorInvalid");
      }
    });
  }

  return (
    <>
          <div className="tab-page-layout-1-list-header mappingstattus-list-header">
            <div className="tab-page-layout-1-li-item  font-bold">Import Id</div>
            <div className="tab-page-layout-1-li-item  font-bold">Source Type</div>
            <div className="tab-page-layout-1-li-item  font-bold">Client Name</div>
            <div className="tab-page-layout-1-li-item  font-bold">Environment Name</div>
            <div className="tab-page-layout-1-li-item  font-bold">Status</div>
            <div className="tab-page-layout-1-li-item  font-bold">Total Records</div>
            <div className="tab-page-layout-1-li-item  font-bold">Success Count</div>
            <div className="tab-page-layout-1-li-item  font-bold">Fail Count</div>
            <div className="tab-page-layout-1-li-item  font-bold">%</div>
            <div className="tab-page-layout-1-li-item  font-bold">Actions</div>
            <div className="tab-page-layout-1-li-item  font-bold" onClick={getAllMappings}>
                <div className="primary-color" >
                <FontAwesomeIcon
                  className="create-icon"
                  icon={["fas", "rotate-right"]}
                  size="xl"
                />
               </div>
            </div>
            {/* <div className="tab-page-layout-1-li-item  font-bold">
              Actions
            </div> */}
            
          </div>
          <ul
            className="tab-page-layout-1-list-section config-list-section"
            id="client-list-section"
          >
            {currentRows.map((item: any, i) => {
              return (
                <li
                  className="tab-page-layout-1-list-item-section mappingstattus-list-item-section"
                  key={i}
                >
                  <div className="tab-page-layout-1-li-item">
                    {item.Import_Id}
                  </div>
        
                  <div className="tab-page-layout-1-li-item">
                    {item.Source_Typ}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    {item.Client_Nm}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    {item.Environment_Nm}
                  </div>
                  <div className={"tab-page-layout-1-li-item" +(item.Status=="Complete"?" text-green":" text-orange")}>
                    {item.Status}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    {item.TotalNumberOfRecords}
                  </div>
                  <div className={"tab-page-layout-1-li-item" +(item.TotalNumberOfErrors>0?" text-green":"")}>
                    {item.RecordsProcessed}
                  </div>
                  <div className={"tab-page-layout-1-li-item" +(item.TotalNumberOfErrors>0?" text-red":"")}>
                    {item.TotalNumberOfErrors}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    {item.PercentageCompletion}%
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    <MappingStatusActions rowData={item} onDelete={getAllMappings}/>
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="tab-page-layout-1-list-footer config-list-footer">
            <div className="row-count-section">
              <div className="row-count-label center-div">Show per page</div>
              <div className="row-count-dropdown-section center-div">
                <select
                  name="filter-column"
                  id=""
                  className="column-dropdown row-count-dropdown  dropdown-arrow-1"
                  onChange={(e) => setRowsPerPage(e.target.value)} 
                >
                  {rowCountRange.map((item: any, i) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="page-number-section center-div">
              <div className="entries-count">
                {rowsPerPage * currentPage - rowsPerPage + 1} to{" "}
                {((rowsPerPage * currentPage)<mappingList.length)?rowsPerPage * currentPage:mappingList.length} of {mappingList.length} entries
              </div>
              <Pagination
                rowsPerPage={rowsPerPage}
                totalRows={mappingList.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
          </div>


       
        
    </>
  );
}

export default MappingStatus;
